module.exports = __webpack_public_path__ + "img/abstract4.d73aa981.jpg";